export default __webpack_public_path__ + "static/media/Mobile_all.6880d32a.png";